import { render, staticRenderFns } from "./BlankDocumentFormModal.vue?vue&type=template&id=f751de7a&scoped=true&"
import script from "./BlankDocumentFormModal.vue?vue&type=script&lang=js&"
export * from "./BlankDocumentFormModal.vue?vue&type=script&lang=js&"
import style0 from "./BlankDocumentFormModal.vue?vue&type=style&index=0&id=f751de7a&lang=scss&scoped=true&"
import style1 from "./BlankDocumentFormModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f751de7a",
  null
  
)

export default component.exports